import { useNavigate } from "react-router-dom";
import { FerramanetasDetalhe } from "../../shared/components/ferramentasDaListagem/ferramentas-detalhe";
import { BaseLayout } from "../../shared/layouts/base-layout-page";
import { useMutation } from "@tanstack/react-query";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { Box, useMediaQuery } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import useLoadingStore from "../../shared/store/loading.store";
import { toastError } from "../../shared/services/errors/erros-handler";
import { CriarUsuariosContract } from "./contracts/criar-usuario.contract";
import {
  CriarUsuarioFormData,
  criarUsuarioSchema,
} from "./schema/criar-usuarios.schema";
import { usuarioService } from "./service/usuario.service";
import { PessoaFisicaFormPart } from "../../shared/components/formulario/parts/PessoaFisicaFormPart/pessoa-fisica.part";
import InputSenha from "../../shared/components/formulario/inputSenha/inputSenha";
import InputMascarado from "../../shared/components/formulario/input-mascarado/InputMascarado";
import { mascaraTelefone } from "../../shared/utils/mascaras";
import { InputFileUpload } from "../../shared/components/formulario/input-file/inputFile";

export function CriarUsuario() {
  const methods = useForm<CriarUsuariosContract>({
    resolver: yupResolver(criarUsuarioSchema),
    defaultValues: {
      active: true,
    },
  });

  const {
    handleSubmit,
    setValue,
    control,
    setError,
    formState: { errors },
  } = methods;

  const { setLoading, stopLoading } = useLoadingStore();

  const { isPending, mutate } = useMutation({
    mutationFn: async (data: CriarUsuarioFormData) => {
      setLoading(true, "Estamos quase lá! Só mais um momento...");
      await usuarioService.criar(data);
    },
    onSuccess: () => {
      toast.success("Usuário criado com sucesso");
    },
    onError: (err: any) => {
      toastError(err);
    },
  });

  const navigate = useNavigate();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <BaseLayout title="Criar Usuário">
      <FerramanetasDetalhe
        mostraBotaoApagar={false}
        mostraBotaoNovo={false}
        mostraBotaoSalvarEVoltar={false}
        mostraBotaoVoltar
        aoClicarBotaoSalvar={handleSubmit((formData) => {
          mutate(formData);
          navigate("/usuarios");
        })}
        aoClicarBotaoVoltar={() => navigate("/usuarios")}
      />
      <Box
        component="form"
        onSubmit={handleSubmit((formData) => {
          mutate(formData);
          navigate("/usuarios");
        })}
        padding="20px 0"
        display="flex"
        flexDirection="column"
        height="calc(100% - 100px )"
        sx={{
          overflowY: "scroll",
        }}
      >
        <PessoaFisicaFormPart methods={methods} mdDown={mdDown} />

        <Box
          display="flex"
          flexDirection={mdDown ? "column" : "row"}
          gap="20px"
          marginTop="20px"
        >
          <InputSenha name="password1" label="Senha" methods={methods} />
          <InputSenha
            name="password2"
            label="Confirme a senha"
            methods={methods}
          />
        </Box>

        <Box>
          <Typography variant="h5" padding="20px 0">
            Contato:
          </Typography>
          <Box
            display="grid"
            gridTemplateColumns={mdDown ? "1fr" : "1fr 1fr 1fr"}
            gap="20px"
            width="100%"
            flexWrap="wrap"
          >
            <TextField
              label="E-mail"
              fullWidth
              {...methods.register("email")}
              error={!!errors.email}
              helperText={errors.email?.message}
              InputLabelProps={{ shrink: true }}
            />

            <InputMascarado
              name="contact1"
              methods={methods}
              label="Telefone"
              mask={mascaraTelefone}
            />

            <InputMascarado
              name="contact2"
              methods={methods}
              label="Telefone"
              mask={mascaraTelefone}
            />
          </Box>
        </Box>

        <br />
        <Controller
          name="active"
          control={control}
          defaultValue={false}
          render={({ field }) => (
            <FormControl>
              <FormLabel>Usuário está ativado?</FormLabel>
              <RadioGroup
                row
                value={field.value ? "true" : "false"}
                onChange={(e) => field.onChange(e.target.value === "true")}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label="Sim"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label="Não"
                />
              </RadioGroup>
            </FormControl>
          )}
        />

        <InputFileUpload
          name="avatar"
          label="Adicione um imagem (JPG ou PNG)"
          methods={methods}
        />
      </Box>
    </BaseLayout>
  );
}
